import { privateKey } from '../constants/routeKeys';
import { useSegments } from 'expo-router';

export const useIsPrivate = () => {
  const segment = useSegments();
  return segment.includes(privateKey);
};
